import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api_getCategoryById } from '~/backend/api_calls';
import { convertImageUrl_S_to_L, convertImageUrl_S_to_M } from '~/backend/helper';
import { isEmpty } from '~/common/helper';

import { useNavigate } from 'react-router-dom';

const ProductCollection = ({ categoryId }) => {
	const { t } = useTranslation();
	const [category, setCategory] = useState({});
	const navigate = useNavigate();

	// Runs once after init rendering
	useEffect(() => {
		api_getCategoryById(categoryId)
			.then(json => {
				setCategory(json);
			})
			.catch(error => console.error(error));
	}, []);

	if (
		isEmpty(category) ||
		(category.img1 === undefined && category.img2 === undefined && category.img3 === undefined && category.img4 === undefined)
	)
		return null;

	return (
		<section id="collection-banner">
			<div className="banner-item ">
				<div className="grid-container">
					<span className="category-intro">{t('category_title')}</span>
					<h3>{category.nm}</h3>
					<span
						dangerouslySetInnerHTML={{
							__html: category.itxt1
						}}></span>
					<div className="images-container">
						<div className="first-part">
							<div className="img-container">
								<img src={convertImageUrl_S_to_M(category.img2)} alt={category.nm} />
							</div>
						</div>
						<div className="second-part">
							<div className="img-container">
								<img src={category.img3} alt={category.nm} />
							</div>
							<div className="img-container">
								<img src={category.img4} alt={category.nm} />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="banner-item" onClick={() => navigate(category.eurl)}>
				<img src={convertImageUrl_S_to_L(category.img1)} alt={category.nm} />
				<div className="title-container">
					<span className="category-intro">{t('category_title')}</span>
					<h3>{category.nm}</h3>
				</div>
			</div>
		</section>
	);
};

export default ProductCollection;

ProductCollection.propTypes = {
	categoryId: PropTypes.any
};
